import { create } from "zustand"

import type { PreferencesTabId } from "@/features/personalization/components/preferences-tabs"

type PreferencesStore = {
  open: boolean
  initialTab: PreferencesTabId
  openWith: (tab: PreferencesTabId) => void
  setOpen: (open: boolean) => void
  close: () => void
}

export const usePreferencesStore = create<PreferencesStore>((set) => ({
  open: false,
  initialTab: "general",
  openWith: (tab) => set({ open: true, initialTab: tab }),
  setOpen: (open) => set({ open }),
  close: () => set({ open: false }),
}))
